export const CHECKOUT_FETCH_ERROR =
  'Não conseguimos carregar os dados do link de pagamento :(<br/>Por favor, tente novamente! Caso o erro persista, entre em contato com a clínica.';

export const SYNC_STATUS_FETCH_ERROR =
  'Não conseguimos verificar o pagamento :(<br/>Por favor, tente novamente! Caso o erro persista, entre em contato com a clínica.';
